require("stylesheets/base.scss");

require("./components/exampleRepresentation/exampleInput.js");

var {grammar, semantics} = require("./language.js");
var {mapSemantics} = require("./components/exampleRepresentation/mapSemantics.js"),
    {SimplifiedCSTNode} = require("./components/exampleRepresentation/simplifyCST.js"),
    {reify} = require("./components/exampleRepresentation/reify.js");
    require("./toAST.js");

var {ThirdEyeExampleVisualization} = require("./components/exampleRepresentation"),
    {GrammarSemantics}  = require("./components/grammarSemantics"),
    {ExampleInput} = require("./components/exampleRepresentation/exampleInput.js"),
    {grammarSlice} = require("./grammarSlice.js");

var keywordTags = grammar.ruleBodies['keyword'].terms.map(term=> term.ruleName);

let exampleNode = document.querySelector('#example');
let example = exampleNode.textContent;
exampleNode.textContent = "";
let match;
try {
  match = grammar.match(example);
} catch (e) {
  console.error(e, match.message);
}

let grammarSemantics, thirdEyeViz, exampleInput;
let gsActions = {
  highlight(...args){return grammarSemantics.highlight(...args);},
  unHighlight(...args){return grammarSemantics.unHighlight(...args);},
  split(...args){return grammarSemantics.split(...args);},
  join(...args){return grammarSemantics.join(...args);}
};
let thirdEyeActions = {
  highlight(...args){return thirdEyeViz.highlight(...args);},
  unHighlight(...args){return thirdEyeViz.unHighlight(...args);},
  split(...args){return thirdEyeViz.split(...args);},
  join(...args){return thirdEyeViz.join(...args);},
  updateSemanticResults(...args){return thirdEyeViz.updateSemanticResults(...args);}
};

thirdEyeViz = new ThirdEyeExampleVisualization(
  document.querySelector('example'),{
    semantics, match, keywordTags, actions: gsActions
  });

grammarSemantics = new GrammarSemantics(
  document.querySelector('.editorWrapper'),{
    grammar, semantics, match, thirdEyeViz(){return thirdEyeViz;}
  });

exampleInput = new ExampleInput(
  document.querySelector('#exampleInput'),{
    example
  }
);
exampleInput.on('exampleChanged', ({example})=> {
  let match = grammar.match(example);
  thirdEyeViz.updateExample(match);
});



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/